import { productState } from './index'
import { Product } from '../../models/product'
import { getDefaultVariant } from './getters'
import { getCurrentVariantId } from '../../services/variants/variants'
import { setSellingPlanGroups } from '../selling-plans/actions'

export const setProductPrice = (price: number) => {
  productState.product.price = price
}

export const setProduct = (product: Product) => {
  productState.product = product
  const currentVariantId = getCurrentVariantId()
  setCurrentVariant(currentVariantId)
  if (productState.currentVariant && productState.currentVariant.price) {
    setProductPrice(productState.currentVariant.price)
  }
  setSellingPlanGroups(product.sellingPlanGroups)
}

export const setCurrentVariant = (variantId: number) => {
  const defaultVariant = getDefaultVariant()
  if (!variantId && !productState.currentVariant && defaultVariant) {
    productState.currentVariant = defaultVariant
    return
  }
  const variant = productState.product.variants.find(v => v.id === variantId)
  if (variant) {
    productState.currentVariant = variant
    return
  }

  if (defaultVariant) {
    productState.currentVariant = defaultVariant
  }
}
